export default __webpack_public_path__ + "9c2ed2e49b5c2df97703def370a57c12.png";